import { isFalsy } from '../utils';

interface ImageUrlProps {
  width: number;
  height: number;
  crop?: string;
  fetchFormat?: string;
  quality?: string;
  backgroundColor?: string;
  noWidth?: boolean;
}

interface BaseConfig {
  width: number;
  ratio: number;
}

export const IMAGE_TRANSFORMATION_DEFAULTS = {
  crop: 'fit',
  fetchFormat: 'auto',
  quality: 'auto:good',
  cropTop: 'crop',
};

export const buildImageUrl = ({
  width,
  height,
  crop = IMAGE_TRANSFORMATION_DEFAULTS.crop,
  fetchFormat = IMAGE_TRANSFORMATION_DEFAULTS.fetchFormat,
  quality = IMAGE_TRANSFORMATION_DEFAULTS.quality,
  backgroundColor,
  noWidth,
}: ImageUrlProps) => {
  if (crop === IMAGE_TRANSFORMATION_DEFAULTS.cropTop) {
    const url = `c_crop,g_north,h_0.7/c_fit,f_${fetchFormat},h_${height},q_${quality}${noWidth ? '' : ',w_' + width}`;
    return !isFalsy(backgroundColor) ? `b_rgb:${backgroundColor},${url}` : url;
  }
  const url = `c_${crop},f_${fetchFormat},h_${height},q_${quality}${noWidth ? '' : ',w_' + width}`;
  return !isFalsy(backgroundColor) ? `b_rgb:${backgroundColor},${url}` : url;
};

export const baseConfig = ({ width, ratio }: BaseConfig) => {
  const { fetchFormat, quality } = IMAGE_TRANSFORMATION_DEFAULTS;
  const height = width * ratio;
  const crop = ratio < 1 ? 'fill' : IMAGE_TRANSFORMATION_DEFAULTS.crop;

  return {
    fetchFormat,
    quality,
    height,
    crop,
  };
};

export const mergedLayer = ({
  srcSetWidths,
  ratio,
  backgroundColor,
  overlayImageId,
}: {
  srcSetWidths: number[];
  ratio: number;
  backgroundColor: string;
  overlayImageId: string;
}) => {
  return srcSetWidths.map(width => {
    const { fetchFormat, quality, height, crop } = baseConfig({ width, ratio });
    const bgTrans = buildImageUrl({
      width,
      height,
      crop,
      fetchFormat,
      quality: 'auto:best',
      backgroundColor,
    });

    return `${bgTrans}/b_rgb:${backgroundColor},c_${crop},f_${fetchFormat},h_${height},l_${overlayImageId},q_${quality},w_${width}`;
  });
};

export const singleImage = ({
  srcSetWidths,
  ratio,
  noWidth,
  crop,
}: {
  srcSetWidths: number[];
  ratio: number;
  noWidth?: boolean;
  crop?: string;
}) => {
  return srcSetWidths.map(width => {
    const { fetchFormat, quality, height, crop: cropConfig } = baseConfig({ width, ratio });

    return buildImageUrl({
      crop: crop ?? cropConfig,
      fetchFormat,
      height,
      quality,
      width,
      noWidth,
    });
  });
};
